import { useAtomValue } from 'jotai';
import { getAllPatientsAtom } from '../../../store/global/atoms';

export const usePatientActions = () => {
  const patientsMutation = useAtomValue(getAllPatientsAtom);

  const syncPatientsWithZoho = async () => {
    return await (patientsMutation.mutate() as unknown as Promise<void>);
  };

  return { syncPatientsWithZoho };
};